// One signing request per storage object across Auth, Settings and headers.
// Signing is enrichment: callers paint cached/fallback identity before awaiting it.
const clients = new WeakMap();
export function signProfileAsset(client, bucket, path) {
  if (!path) return Promise.resolve({ data: null, error: null });
  let cache = clients.get(client);
  if (!cache) { cache = new Map(); clients.set(client, cache); }
  const key = JSON.stringify([bucket, path]);
  const existing = cache.get(key);
  if (existing && existing.expiresAt > Date.now()) return existing.promise;
  const entry = { expiresAt: Date.now() + 8 * 60_000, promise: null };
  entry.promise = Promise.resolve().then(() => client.storage.from(bucket).createSignedUrl(path, 600))
    .catch(() => ({ data: null, error: { code: 'asset_signing_unavailable' } }))
    .then(result => {
      if (result?.error || !result?.data?.signedUrl) entry.expiresAt = Date.now() + 5000;
      return result;
    });
  cache.set(key, entry);
  return entry.promise;
}
